import { render, staticRenderFns } from "./InsuranceCatalogV2.vue?vue&type=template&id=03c0e847&scoped=true&"
import script from "./InsuranceCatalogV2.vue?vue&type=script&lang=js&"
export * from "./InsuranceCatalogV2.vue?vue&type=script&lang=js&"
import style0 from "./InsuranceCatalogV2.vue?vue&type=style&index=0&id=03c0e847&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c0e847",
  null
  
)

export default component.exports